
import { Modal } from 'antd';
import "./indexModal.css";
import "antd/dist/antd.css";

const ModalConfirm = ({
    textTitle, 
    textContent,
    textCancel,
    textSubmit,
    visible, 
    setVisible,
    submit,
    textContent2
}) => {

    const styleModal={
        width: '100%',
        height: 209,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
    };
    const styleContent={
        display: 'flex', 
        flexDirection: 'column', 
        width: '100%', 
        height: 100, 
        justifyContent: 'center', 
        alignItems: 'center', 
    };
    const styleButton={
        display: 'flex', 
        flexDirection: 'row',
        width: '100%', 
        height: 100, 
        justifyContent: 'center', 
        alignItems: 'flex-end', 
    };

    return (
        <Modal
            bodyStyle={styleModal}
            className="newStyle"
            centered
            closable={false}
            visible={visible}
            footer={null}
            onCancel={() => setVisible(!visible)}
        >
            <div style={styleContent}>
                <p style={{ fontSize: 17, fontWeight: 'bold'}}>{textTitle}</p>
                <p style={{ fontSize: textContent === '登録しますか'? 18:12.5, fontWeight: 'normal', marginTop:15}}>{textContent}</p>
                <p style={{ fontSize: 12.5, fontWeight: 'normal', marginTop:-10}}>{textContent2}</p>
            </div>
        
            <div 
                style={styleButton}>
                <div
                    style={{ marginRight:10}}
                    onClick={()=>setVisible(false)}
                    className="btn-confirm">
                    <h6 className="text-submits">{textCancel}</h6>
                </div>
                <div
                    style={{ marginLeft:10}}
                    onClick={submit}
                    className="btn-confirm ok">
                    <h6 className="text-submits">{textSubmit}</h6>
                </div>
            </div>
        </Modal>
    );
};

export default ModalConfirm;

